import { IConversation } from 'src/interfaces/conversation';
import {
    NEWS_LEAD_TYPE,
    PREOWNEDS_LEAD_TYPE,
    BDC_LEAD_TYPE,
    SERVICE_LEAD_TYPE,
} from 'src/constants/lead/leadTypes';
import { getDocumentId } from 'src/utils/mongo/getDocumentId';

/**
 * Returns a formatted redirect URL based on the lead type associated with a conversation.
 *
 * Depending on the conversation's area, the function generates a URL that points to the
 * corresponding management section (e.g., leads or BDC).
 *
 * @param {IConversation} conversation - The conversation object containing lead and area information.
 * @returns {string} The formatted URL for redirection.
 */

export const formatRedirectUrlLead = (conversation: IConversation) => {
    const leadId = getDocumentId(conversation.lead);

    switch (conversation.area) {
        case NEWS_LEAD_TYPE:
        case PREOWNEDS_LEAD_TYPE:
            return `/management/leads/${leadId}`;
        case BDC_LEAD_TYPE:
            return `/management/bdc/${leadId}`;
        case SERVICE_LEAD_TYPE:
            return `/management/service-clients/${leadId}`;
        default:
            return `/management/leads/${leadId}`;
    }
};
